import Vue from "vue";
import Vuex from "vuex";

import { account } from "./modules/account.module";
import { alert } from "./modules/alert.module";
import { app } from "./modules/app.module";
import { device } from "./modules/device.module";
import point from "./modules/point.module.js";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    account,
    alert,
    app,
    device,
    point,
  },
});
